import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["title", "url"];
import React, { useEffect, useState } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var YoutubeVideo = _ref => {
  var {
    title,
    url = ""
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var [src, setSrc] = useState();
  useEffect(() => {
    var match = /(\?v=|youtu\.be\/|vimeo\.com\/)([a-zA-Z0-9-]+)/.exec(url);
    if (!match || match.length < 2) return;
    var id = match[2];
    setSrc(["vimeo.com/"].includes(match[1]) ? "https://player.vimeo.com/video/" + id + "?title=0&byline=0&portrait=0" : "https://youtube.com/embed/" + id);
  }, [url]);
  return /*#__PURE__*/_jsx("iframe", _extends({
    className: "w-full aspect-video",
    "data-chromatic": "ignore",
    title: title,
    width: "100%",
    height: "100%",
    src: src
  }, rest));
};
//# sourceMappingURL=youtube_video.js.map